import { useFeature } from '@/composables/feature'
import { useRoute } from '@/composables/route'

/**
 * Inhalte at organisation level, the Zentrale Inhalte package (Arnold, 22 Oct 2026): the sidebar and header
 * entry opens the start page from the navigation (`from=menu`), which sends on to an available area, or shows
 * the offboarding in the read window, or the one onboarding. The section column links each area directly
 * while it is on, else the start page for that area (the package offer).
 */
export const orgContentHref = () => useRoute('content.start', { from: 'menu' })

export const orgMediaHref = () =>
  useFeature('dam')
    ? useRoute('dam.web.index')
    : useRoute('content.start', { area: 'media' })

export const orgTextsHref = () =>
  useFeature('content')
    ? useRoute('content.texts.index')
    : useRoute('content.start', { area: 'texts' })

/** The section column Medien / Texte shows once one area is on (UX1). */
export const orgContentAvailable = () =>
  useFeature('dam') || useFeature('content')

/**
 * The classic header and the mobile menu name both areas: each opens the start page for its area from the
 * navigation, so the read window shows the offboarding there too (UX2, Codex review).
 */
export const orgMediaMenuHref = () =>
  useRoute('content.start', { area: 'media', from: 'menu' })

export const orgTextsMenuHref = () =>
  useRoute('content.start', { area: 'texts', from: 'menu' })
